import React from 'react';

import * as analytics from '~/libs/analytics';
import Cookies from 'js-cookie';

export interface eventProperties {
  path: string;
  url: string;
  referrer: string;
  title: string;
  fbclid?: string;
  gclid?: string;
}

const getDefaultProperties = (): eventProperties => {
  const doc = document || {
    location: { pathname: 'unknown', href: 'unknown' },
    referrer: 'unknown',
    title: 'unknown',
  };
  const eventProperties: eventProperties = {
    path: doc.location.pathname,
    url: doc.location.href,
    referrer: doc.referrer,
    title: doc.title,
  };

  const FBCLID = Cookies.get('fbclid');
  const GCLID = Cookies.get('gclid');

  if (FBCLID) {
    eventProperties.fbclid = FBCLID;
  }
  if (GCLID) {
    eventProperties.gclid = GCLID;
  }
  return eventProperties;
};

export const trackPage: typeof analytics.trackPage = (name, properties) => {
  const defaultProperties = getDefaultProperties();
  analytics.trackPage(name, { ...defaultProperties, ...properties });
};

export const trackAction: typeof analytics.trackAction = (
  name,
  properties,
  options,
) => {
  const defaultProps = getDefaultProperties();
  analytics.trackAction(name, { ...defaultProps, ...properties }, options);
};

export interface EventData<T> {
  name: string;
  props?: T;
}

export type GenericEventData = EventData<object>;

export const onClickTrackAction = (event: GenericEventData) => {
  return (clickEvent: React.MouseEvent) => {
    const target = clickEvent.target as HTMLElement;
    const defaultProps = {
      ['cta_text']: target.textContent?.trim(),
      page_location: 'dev-hub',
    };

    if (event) {
      trackAction(event.name, { ...defaultProps, ...event.props });
    }
  };
};
